import deepClone from "~/utils/deepClone";

function getFormDataAndTransformMedia({payload}) {
    let formData = new FormData();

    if(payload.media || payload.mediaFiles){
        const mediaToProcess = payload.mediaFiles?.value.filter(media => media && !media.existing);
        const mediaIdsToDelete = payload.mediaFiles?.itemsForDelete.map(media => (media.id));

        if(payload.media){
            let existingMedia = Array.isArray(payload.media) ? deepClone(payload.media) : deepClone([payload.media]);
            if(mediaIdsToDelete && mediaIdsToDelete.length){
                existingMedia = existingMedia.filter(media => mediaIdsToDelete.indexOf(media.id) === -1);
            }
            formData.append('media', existingMedia.length ? JSON.stringify(existingMedia) : JSON.stringify([]));
        }


        if(mediaToProcess){
            payload.mediaToProcess = mediaToProcess.map(media => {
                return {
                    blob: media.file,
                    title: media.file.name
                };
            });
        }

        if(payload.mediaToProcess && payload.mediaToProcess.length > 0) {
            payload.mediaToProcess.forEach(function (media) {
                if(!media.hasOwnProperty('id')) {
                    formData.append('mediaToProcess[]', media.blob, media.title);
                }
            });
        }
        delete payload.mediaToProcess;
    }

    for (const key of Object.keys(payload)) {
        if(key !== 'media' && key !== 'mediaFiles'){
            const value = payload[key];

            if (Array.isArray(value)) {
                if (value.length === 0) {
                    formData.append(key, '');
                } else {
                    value.forEach(item => {
                        formData.append(`${key}[]`, item);
                    });
                }
                continue;
            }

            if(value === null || value === undefined) {
                payload[key] = '';
            }
            formData.append(key, payload[key]);
        }
    }
    return formData;
}

export default getFormDataAndTransformMedia;